import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconGuidanceBoost = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <path
        d="M6.54914 6.0265C4.79809 4.83177 1.89134 5.16497 1.46496 6.81247C1.39803 7.0711 1.55203 7.32356 1.78086 7.46141L4.68561 9.21126"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4738 9.95215C11.6686 11.7033 11.3364 14.6102 9.68786 15.0364C9.42922 15.1032 9.17676 14.9493 9.03891 14.7204L7.28906 11.8157"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.68555 9.2029L7.29843 11.8158C9.38874 10.5636 11.765 9.3508 12.8496 8.22677C14.6708 6.40557 14.259 4.06177 13.9833 3.10344C13.9012 2.81804 13.6833 2.6001 13.3979 2.51799C12.4396 2.24228 10.0958 1.83056 8.27457 3.65175C7.15053 4.73635 5.9279 7.12245 4.68555 9.2029Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.77983 12.9663C4.89013 13.856 3.23093 13.4246 3.23093 13.4246C3.23093 13.4246 2.86606 11.6991 3.68952 10.876"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconGuidanceBoost.displayName = 'IconGuidanceBoost';
